import Components from "../components";

class TeamInvite extends Components.Base {
  bind() {
    this.on("ajax:success", (...args) => this.onSuccess(...args));
  }

  onSuccess() {
    this.$el.find("#team_invitation_email").val("").focus();
  }
}

Components.collection.register({
  selector: ".c-team-invite",
  klass: TeamInvite,
});
